import React, {Component} from 'react';
import {Modal} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import Agent from "../../../Network/Agent";
import ToolBar from "../../../Components/Elements/ToolBar";
import {BASE_URL} from "../../../Config/SharedConfig";
import BottomSheetAction from "../../../Components/Elements/BottomSheet/BottomSheetAction";
import BottomSheetConfirm from "../../../Components/Elements/BottomSheet/BottomSheetConfirm";
import {ActionButtonsEnum} from "../../../Components/Elements/BottomSheet/Enum/ActionButtonsEnum";
import ButtonPrimary from "../../../Components/Elements/ButtonPrimary";


class SocialListForOwnerInternal extends Component {


    constructor(props) {
        super(props);
        this.state = {
            storeUsername : window.location.host.split('.')[0],
            storeSocials: [],
            globalSocials : [] ,
            selectedSocial : {},
            selectValue : 'none',
            socialNameValue : '',
            modal: {
                newSocialMedia : false,
                editSocialMedia : false,
                actions: false,
                confirmDeleteSocial : false
            },
            isLoading : {
                newSocialMedia : false,
                editSocialMedia : false,
                confirmDeleteSocial : false
            },
            underConstructionSocialCode : '',
            underConstructionSocialName : ''
        }
    }

    toggleModal = (target) => e => {
        let modal = this.state.modal
        modal[target] = !modal[target]
        this.setState({
            modal
        })
    }


    openActionsModalForSocial = (social) => (e) => {
        this.setState({
            underConstructionSocialCode : social.code,
            underConstructionSocialName : social.data,
            modal : {
                actions : true
            }
        })
    }
    onBottomSheetCallBack = (type , data) => {
        if (type === 'edit') {
            this.setState({
                modal : {
                    editSocialMedia : true
                },
                // underConstructionSocialName : data.data
            })
        }
        if (type === 'delete') {
            this.setState({
                modal : {
                    confirmDeleteSocial : true
                },
                // underConstructionSocialCode : data.code
            })
        }
    }
    onBottomSheetConfirmDeleteSocialCallBack = (type , data) => {
        if (type === 'positive') {
            this.setState({
                isLoading : {
                    confirmDeleteSocial : true
                }
            })
            Agent.SocialMedia.delete(this.state.storeUsername , this.state.underConstructionSocialCode)
                .then(response => {
                    this.setState({
                        modal : {
                            confirmDeleteSocial : false
                        },
                        isLoading : {
                            confirmDeleteSocial : false
                        }
                    })
                    this.getSocialList()
                })
                .catch(error => {
                    console.log(error.response)
                })
        }
        if (type === 'negative') {
            this.setState({
                modal : {
                    confirmDeleteSocial : false
                }
            })
        }
    }

    getSocialList = () => {
        Agent.SocialMedia.getList(this.state.storeUsername)
            .then(response => {
                let socials = response.data.result.socials
                this.setState({
                    storeSocials : socials
                })
            })
            .catch(error => {
                console.log(error.response)
            })
    }

    onSocialTypeSelect = (e) => {
        let value = e.target.value
        let socialMedia = this.state.globalSocials.find((item) => {
            return item.key === value
        })
        console.log(socialMedia)
        this.setState({
            selectedSocial : socialMedia,
            selectValue : value
        })
    }

    onChangeSocialName = (e) => {
        let value = e.target.value
        this.setState({
            socialNameValue : value
        })
    }
    onChangeSocialNameEdit = (e) => {
        let value = e.target.value
        this.setState({
            underConstructionSocialName : value
        })
    }

    onAddSocialSubmit = (e) => {
        e.preventDefault()
        this.setState({
            isLoading : {
                newSocialMedia : true
            }
        })
        let data = {
            key : this.state.selectValue,
            data : this.state.socialNameValue
        }
        Agent.SocialMedia.create(this.state.storeUsername , data)
            .then(response => {
                this.setState({
                    modal : {
                        newSocialMedia : false
                    },
                    isLoading : {
                        newSocialMedia : false
                    },
                    selectValue : 'none',
                    socialNameValue : '',
                    selectedSocial : {},
                })
                this.getSocialList()
            })
            .catch(error => {
                console.log(error.response)
                this.setState({
                    isLoading : {
                        newSocialMedia : false
                    }
                })
            })
    }
    onEditSocialSubmit = (e) => {
        e.preventDefault()
        this.setState({
            isLoading : {
                editSocialMedia : true
            }
        })
        console.log(this.state.underConstructionSocialCode , this.state.underConstructionSocialName)
        Agent.SocialMedia.edit(this.state.storeUsername , this.state.underConstructionSocialCode , this.state.underConstructionSocialName)
            .then(response => {
                this.setState({
                    modal : {
                        editSocialMedia : false
                    },
                    isLoading : {
                        editSocialMedia : false
                    },
                    underConstructionSocialCode : '',
                    underConstructionSocialName : ''
                })
                this.getSocialList()
            })
            .catch(error => {
                console.log(error.response)
                this.setState({
                    isLoading : {
                        editSocialMedia : false
                    }
                })
            })
    }

    componentDidMount() {

        this.getSocialList()
        Agent.SocialMedia.getPatterns()
            .then(response => {
                let patterns = response.data.result.patterns
                this.setState({
                    globalSocials : patterns
                })
            })
            .catch(error => {
                console.log(error.response)
            })
    }


    render() {
        return (
            <>
                <ToolBar title={'شبکه های اجتماعی'} navigate={this.props.toolbarNavigate} />

                <div className='container'>
                    <div className={'row'}>
                        <div className={'col-12'}>
                            <div className={'mobile-subtitle-regular cl-subtitle mt-8'}>
                                برای نمایش تنظیمات و یا حذف  روی ایتم مورد نظر ضربه بزنید
                            </div>
                        </div>
                    </div>

                    <div className={'row'}>
                        {/* open modal */}
                        <div className={'col-12'}>
                            <div className={'add-sub-product-box cursor-pointer mt-20'} onClick={this.toggleModal('newSocialMedia')}>
                                <div className='d-flex justify-content-center'>
                                    <div className={'img-cnt-24'}>
                                        <img src={"/assets/images/vectors/plus_lightblue.svg"}/>
                                    </div>
                                </div>
                                <div className={'mobile-subtitle-strong cl-blue mt-8 text-center'}>
                                    اضافه کردن شبکه اجتماعی
                                </div>
                            </div>
                        </div>

                        <div className={'col-12 mt-20'}>
                            {
                                this.state.storeSocials.map(social => {
                                    return (
                                        <div key={social.code} onClick={this.openActionsModalForSocial(social)}
                                             className={'d-flex align-items-center justify-content-between pt-20 pb-20'}>
                                            <div className='d-flex align-items-center'>
                                                <div className='img-cnt-24'>
                                                    <img src={BASE_URL+social.icon} alt={social.title}/>
                                                </div>
                                                <div className='mr-20'>
                                                    <div className='mobile-body-1-strong cl-subtitle'>
                                                        { social.title }
                                                    </div>
                                                    <div className={'mobile-h5 cl-black mt-custom-2 dir-ltr'}>
                                                        { social.data }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={'d-flex align-items-center'}>
                                                <div className={'img-cnt-20 mr-20'}>
                                                    <img src={"/assets/images/vectors/more_black.svg"} alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>

                    </div>
                </div>

                <div className='scroll-fixer'/>

                <Modal className='bottom-sheet fade in' show={this.state.modal.newSocialMedia}
                       onHide={this.toggleModal('newSocialMedia')}>
                    <Modal.Body>
                        <div className='d-flex justify-content-center pt-10 pb-10' onClick={this.toggleModal('newSocialMedia')}>
                            <div className='bottom-sheet-close-line btn p-0 '/>
                        </div>
                        <form onSubmit={this.onAddSocialSubmit}>
                            <div className={'row'}>
                                <div className={'col-12'}>
                                    <div className={'mobile-h3 cl-black mt-10'}>
                                        انتخاب نوع لینک
                                    </div>
                                </div>
                                <div className={'col-12'}>
                                    <div className={'mobile-subtitle-regular cl-black mt-8'}>
                                        لینک مورد نظر خود را انتخاب کنید :
                                    </div>
                                </div>
                            </div>
                            <div className={'row'}>
                                {/* title */}
                                <div className={'col-12'}>
                                    <div className='form-group-select-option mt-8'>
                                        <select className='form-group-select'
                                                name='key'
                                                value={this.state.selectValue}
                                                onChange={this.onSocialTypeSelect}>
                                            <option className='form-group-option' value='none' disabled hidden>
                                                انتخاب کنید
                                            </option>
                                            {
                                                this.state.globalSocials.map(social => {
                                                    return(
                                                        <option key={social.key} value={social.key} className='form-group-option'>
                                                            { social.title_fa }
                                                        </option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                {/* price */}
                                <div className={'col-12'}>
                                    <div className={'form-group-input-primary mt-16'}>
                                        <label className={'form-group-label'}>
                                            <div className='mobile-subtitle-strong cl-black'>
                                                اطلاعات لینک
                                            </div>
                                            <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                                                اطلاعات مورد نیاز لینک خود را وارد کنید
                                            </div>
                                            <input type="text"
                                                   onChange={this.onChangeSocialName}
                                                   className={'form-group-input dir-ltr mt-10'}
                                                   placeholder={this.state.selectedSocial.placeholder || ""}/>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-32'>
                                <ButtonPrimary text='ثبت'
                                               mode='dark-mode'
                                               isLoading={this.state.isLoading.newSocialMedia}/>
                            </div>
                        </form>

                    </Modal.Body>
                </Modal>

                <Modal className='bottom-sheet fade in' show={this.state.modal.editSocialMedia}
                       onHide={this.toggleModal('editSocialMedia')}>
                    <Modal.Body>
                        <div className='d-flex justify-content-center pt-10 pb-10' onClick={this.toggleModal('editSocialMedia')}>
                            <div className='bottom-sheet-close-line btn p-0 '/>
                        </div>
                        <form onSubmit={this.onEditSocialSubmit}>
                            <div className={'row'}>
                                {/* price */}
                                <div className={'col-12'}>
                                    <div className={'form-group-input-primary mt-16'}>
                                        <label className={'form-group-label'}>
                                            <div className='mobile-subtitle-strong cl-black'>
                                                اطلاعات لینک
                                            </div>
                                            <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                                                اطلاعات مورد نیاز لینک خود را وارد کنید
                                            </div>
                                            <input type="text"
                                                   onChange={this.onChangeSocialNameEdit}
                                                   value={this.state.underConstructionSocialName || ""}
                                                   className={'form-group-input dir-ltr mt-10'}
                                                   placeholder={""}/>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-32'>
                                <ButtonPrimary text='ویرایش'
                                               mode='dark-mode'
                                               isLoading={this.state.isLoading.editSocialMedia}/>
                            </div>
                        </form>

                    </Modal.Body>
                </Modal>

                <BottomSheetAction show={this.state.modal.actions}
                                   onHide={this.toggleModal('actions')}
                                   data={this.state.underConstructionSocialCode}
                                   buttons={[
                                       ActionButtonsEnum.DELETE ,
                                       ActionButtonsEnum.EDIT ,
                                   ]}
                                   action={this.onBottomSheetCallBack} />

                <BottomSheetConfirm show={this.state.modal.confirmDeleteSocial}
                                    onHide={this.toggleModal('confirmDeleteSocial')}
                                    title={"حذف شبکه اجتماعی"}
                                    body='آیا از حذف این مورد اطمینان دارید ؟'
                                    data={this.state.underConstructionSocialCode}
                                    action={this.onBottomSheetConfirmDeleteSocialCallBack}
                                    isLoading={this.state.isLoading.confirmDeleteSocial}
                                    btnText='حذف' />

            </>
        );
    }
}

const SocialListForOwner = () => {
    const navigate = useNavigate()
    return <SocialListForOwnerInternal toolbarNavigate={() => navigate(-1)} />
}


export default SocialListForOwner